export const ActionPragmaticInfo = {
  LOAD_HOME_PRAGMATIC_INFO: '[Home Pragmatic Info] Load State Home Pragmatic Info',

  /* Logged user */
  LOAD_PRAGMATIC_LOGED_USER: '[Pragmatic Loged User] Carga la información del Pragmatico logueado',
  LOAD_PRAGMATIC_LOGED_USER_SUCCESSFULLY: '[Pragmatic Loged User] Carga la información del Pragmatico logueado exitosamente',
  LOAD_PRAGMATIC_LOGED_USER_FAILURE: '[Pragmatic Loged User] Carga la información del Pragmatico logueado fallida',

  /* Profile */
  LOAD_PRAGMATIC_PROFILE: '[Pragmatic Info Page] Carga la información de perfil',
  LOAD_PRAGMATIC_PROFILE_SUCCESSFULLY: '[Pragmatic Info Page] Carga la información de perfil exitosamente',
  LOAD_PRAGMATIC_PROFILE_FAILURE: '[Pragmatic Info Page] Carga la información de perfil fallida',

  /* Chapter details */
  LOAD_PRAGMATIC_CHAPTER_DETAILS: '[Pragmatic Info Page] Carga el detalle de chapter(s) del Pragmatico',
  LOAD_PRAGMATIC_CHAPTER_DETAILS_SUCCESSFULLY: '[Pragmatic Info Page] Carga el detalle de chapter(s) del Pragmatico exitosamente',
  LOAD_PRAGMATIC_CHAPTER_DETAILS_FAILURE: '[Pragmatic Info Page] Carga el detalle de chapter(s) del Pragmatico fallida',

  /* Current chapter */
  LOAD_PRAGMATIC_CURRENT_CHAPTER_DETAILS: '[Pragmatic Info Page] Carga el detalle del chapter actual del Pragmatico',
};
